import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectMyRequest, selectTeamMemberById, selectTeamRequest } from '@store/actions/TeamMemberAction';

import ApiClient from '@lib/apiClient';

import { checkAnyUserType, getUserInfo } from '@utils/Util';

const UsersForTeamLead = () => {
	const [showOption, setShowOption] = useState(false);
	const [memberList, setMemberList] = useState([]);
	const [allMembers, setAllMembers] = useState([]);
	const dispatch = useDispatch();
	const searchRef = useRef();
	const dropdownRef = useRef(null);
	const myTeamMembers = useSelector((store) => store.teamMembersReducer);
	const myRef = useRef();

	const showFilter = () => {
		return getUserInfo().isTeamLead && !checkAnyUserType(['COSTING_MANAGER', 'SAMPLE_DEVELOPMENT']);
	};

	const handleClickOutside = (event) => {
		if (myRef && !myRef.current.contains(event.target)) {
			setShowOption(false);
		}
	};

	useEffect(() => {
		document.body.addEventListener('keydown', handleKeyDown);
		return () => {
			document.body.removeEventListener('keydown', handleKeyDown);
		};
	}, []);

	const handleKeyDown = (event) => {
		if (
			document.activeElement.getAttribute('class') === 'team-search-box' ||
			document.activeElement.getAttribute('class') === 'team-item-focus'
		) {
			const isUp = event.key === 'ArrowUp';
			const isDown = event.key === 'ArrowDown';
			const inputIsFocused = document.activeElement === searchRef.current;
			const resultsItems = Array.from((dropdownRef.current && dropdownRef.current.children) || []);
			const activeResultIndex = resultsItems.findIndex((child) => {
				return child.querySelector('p') === document.activeElement;
			});

			if (isUp) {
				event.preventDefault();
				if (inputIsFocused) {
					resultsItems[resultsItems.length - 1].querySelector('p').focus();
				} else if (resultsItems[activeResultIndex - 1]) {
					resultsItems[activeResultIndex - 1].querySelector('p').focus();
				} else {
					searchRef.current && searchRef.current.focus();
				}
			}

			if (isDown) {
				event.preventDefault();
				if (inputIsFocused) {
					resultsItems[0].querySelector('p').focus();
				} else if (resultsItems[activeResultIndex + 1]) {
					resultsItems[activeResultIndex + 1].querySelector('p').focus();
				} else {
					searchRef.current && searchRef.current.focus();
				}
			}
		}
	};

	useEffect(() => {
		if (showFilter()) {
			document.addEventListener('mousedown', handleClickOutside);

			ApiClient.GET('fetchMyTeamMembers').then((response) => {
				setAllMembers(response.data);
				setMemberList(response.data);
			});

			return () => {
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}
	}, []);

	const onUserClick = (item) => {
		dispatch(selectTeamMemberById(item));
	};

	const onMyRequestClick = () => {
		dispatch(selectMyRequest(!myTeamMembers.isMy));
	};

	const onTeamRequestClick = () => {
		dispatch(selectTeamRequest(!myTeamMembers.isTeam));
	};

	const renderMemberList = () => {
		return memberList?.map((item) => {
			return (
				<div
					className={
						myTeamMembers.selectedUsers.find((user) => user.id === item.id)
							? 'single-item selected'
							: 'single-item'
					}
					key={`member_${item.id}`}
				>
					<p
						className="team-item-focus"
						onClick={() => onUserClick(item)}
						tabIndex={0}
						onKeyDown={(e) => {
							if (e.keyCode === 13) {
								onUserClick(item);
							}
						}}
					>
						{item.name}
					</p>
				</div>
			);
		});
	};

	const handleSearch = (e) => {
		let filteredMembers = allMembers?.filter(
			(item) => item.name.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1
		);
		setMemberList(filteredMembers);
	};

	if (showFilter()) {
		return (
			<div className="select-component selectUser-teamLead" ref={myRef}>
				<div
					className="click-box click mb-1"
					onClick={() => {
						setShowOption((prev) => !prev);
						setTimeout(() => {
							searchRef.current.focus();
						}, 0);
					}}
				>
					<p className="regular-14 gray_dark_01">Select User</p>
					<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
				</div>
				<div
					className={showOption ? 'dropdown-box' : 'dropdown-box d-none'}
					style={{ maxWidth: '210px' }}
				>
					<div className="m-0 search-filter">
						<div className="with-icon right-icon">
							<input
								ref={searchRef}
								className="team-search-box"
								type="text"
								autoComplete="off"
								placeholder="Search"
								onChange={handleSearch}
							/>
							<span className="right-icon">
								<img src={`${process.env.PUBLIC_URL}/icons/search.png`} alt="" />
							</span>
						</div>
					</div>
					<div className="list-items scroll-y-label" ref={dropdownRef}>
						<div className={myTeamMembers.isMy ? 'single-item selected' : 'single-item'}>
							<p
								className="team-item-focus"
								onClick={onMyRequestClick}
								tabIndex={0}
								onKeyDown={(e) => {
									if (e.keyCode === 13) {
										onMyRequestClick();
									}
								}}
							>
								My Requests
							</p>
						</div>
						<div className={myTeamMembers.isTeam ? 'single-item selected' : 'single-item'}>
							<p
								className="team-item-focus"
								onClick={onTeamRequestClick}
								tabIndex={0}
								onKeyDown={(e) => {
									if (e.keyCode === 13) {
										onTeamRequestClick();
									}
								}}
							>
								Team Requests
							</p>
						</div>
						{/*<hr/>*/}
						{renderMemberList()}
					</div>
				</div>
			</div>
		);
	} else {
		return '';
	}
};

export default UsersForTeamLead;
